import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import socketMiddleware from '../middleware/socketMiddleware';
import reducer from './index';
import _ from 'lodash';

const isServer = typeof window === 'undefined';

const defaultMiddlewares = [promiseMiddleware, thunkMiddleware];

const clientMiddlewares = [socketMiddleware()];

const middlewares = [
  ...defaultMiddlewares,
  ...(isServer ? [] : clientMiddlewares),
];

export default function initializeStore(initialState = {}) {
  let store = createStore(
    reducer,
    initialState,
    compose(applyMiddleware(...middlewares)),
  );

  return store;
}